import React from 'react';
import styled from 'styled-components';
import bosch from '../../../assets/images/LogoClient/bosch.png';
import collins from '../../../assets/images/LogoClient/Collins-Aerospace.png';
import estra from '../../../assets/images/LogoClient/estra.png';
import honeywell from '../../../assets/images/LogoClient/Honeywell_logo_PNG1.png';
import Kubota from '../../../assets/images/LogoClient/Kubota.png';
import hitachi from '../../../assets/images/LogoClient/tata-hitachi.png';
import Thermax from '../../../assets/images/LogoClient/Thermax.png';
import unilever from '../../../assets/images/LogoClient/unilever.png';
import yazaki from '../../../assets/images/LogoClient/yazaki.png';
import shaktiman from '../../../assets/images/LogoClient/shaktiman.png';
import danieli from '../../../assets/images/LogoClient/danielicorus.png';
import ador from '../../../assets/images/LogoClient/Ador_Welding_logo.png';
import sparkonix from '../../../assets/images/LogoClient/sparkonix.png';
import IBM from '../../../assets/images/LogoClient/IBM.png';
import Infinity from '../../../assets/images/LogoClient/Infinity.png';
import Infosys from '../../../assets/images/LogoClient/Infosys.png';
import Accenture from '../../../assets/images/LogoClient/Accenture.png';
import HCL from '../../../assets/images/LogoClient/HCL.png';
import Index from '../../../assets/images/LogoClient/Index.png';
import ACG from '../../../assets/images/LogoClient/ACG.png';
import Electrr from '../../../assets/images/LogoClient/Electrr.png';
import Bajaj from '../../../assets/images/LogoClient/Bajaj.png';
import Lm_wind_power from '../../../assets/images/LogoClient/Lm_wind_power.png';
import LandT from '../../../assets/images/LogoClient/L&T.png';


const Section = styled.section`
  padding: 50px 20px;
  min-height: 80vh;
  @media (max-width: 768px) {
    padding: 40px 15px;
  }

  @media (max-width: 576px) {
    padding: 30px 10px;
  }
`;

const Title = styled.h4`
  font-size: 3em;
  text-align: left;
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  font-style: normal;
  color: #06334b;

  @media (max-width: 768px) {
    font-size: 2.5rem;
  }

  @media (max-width: 576px) {
    font-size: 1.95em;
  }
`;

const TitleSpan = styled.span`
  color: #07b6f2;
`;

const Container = styled.div`
  margin-top: 2rem;
  border: 2px solid #f1f1f1;
  max-height: 500px;
  overflow-y: auto;
`;

const ClientLogo = styled.img`
  max-width: 100%; /* Reduce the size of the logo */
  height: auto;
  margin: 0 auto; /* Center the logo horizontally */
  display: block; /* Ensures the logo is treated as a block-level element for centering */
  transition: transform 0.3s;

  &:hover {
    transform: scale(1.1);
  }

  @media (max-width: 576px) {
    max-width: 60%; /* Adjust the size further for smaller screens */
    gap: 1rem;
  }
`;

const OurClients = () => {
  const customers = [
    
    { name: 'Bajaj', logo: Bajaj},
   
    { name: 'hitachi', logo: hitachi},

    { name: 'yazaki', logo: yazaki},
    { name: 'Thermax', logo: Thermax},
    { name: 'Lm_wind_power', logo: Lm_wind_power},
   

    { name: 'shaktiman', logo: shaktiman},
    { name: 'estra', logo: estra},
    { name: 'ACG', logo: ACG},
    { name: 'danieli', logo: danieli },

    { name: 'bosch', logo: bosch},
    
    { name: 'L&T', logo: LandT},
    { name: 'Kubota', logo: Kubota},

  

   /* { name: 'collins', logo: collins},
    { name: 'honeywell', logo: honeywell},
    { name: 'ador', logo: ador },
    { name: 'unilever', logo: unilever},
    { name: 'sparkonix', logo: sparkonix},
    { name: 'IBM', logo: IBM},
    { name: 'Infosys', logo: Infosys },
    { name: 'Accenture', logo: Accenture },
    { name: 'HCL', logo: HCL},
    { name: 'Infinity', logo: Infinity},
    { name: 'Index', logo: Index},
    { name: 'Electrr', logo: Electrr}*/

  ];

  return (
    <Section className="ourclients-section">
      <div className="container">
        <Title className="display-5 fw-bold text-left ourclients-h2 mb-5">
          Our Valuable <TitleSpan>Clients</TitleSpan>
        </Title>

        <Container className="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-4 justify-content-center">
          {customers.map((customer, index) => (
            <div key={index} className="col text-center">
           
                <ClientLogo
                  src={customer.logo}
                  alt={`${customer.name} Logo`}
                  className="img-fluid client-logo"
                />
         
            </div>
          ))}
        </Container>
      </div>
    </Section>
  );
};

export default OurClients;
